import type {
	StartergyPostTradeDetails,
	StrategyIds,
	StrategyPosition,
	StrategyType
} from '$lib/types/strategy';
import { api_strategies, api_strategies_ssr } from './utils';

export async function getAllStrategies(ssr = false, fetch?: any) {
	const response = ssr
		? await api_strategies_ssr(fetch, 'get', 'v1/arbitrage-strategies')
		: await api_strategies('get', 'v1/arbitrage-strategies');

	if (response.status === 200) {
		const data = await response.json();
		return data as Array<StrategyType>;
	}
}

export async function getStrategiesPostTradeDetails(
	startergyId: StrategyIds,
	longMargin: string,
	shortMargin: string,
	longSize: string,
	shortSize: string,
	smartContractWalletAddress: string
) {
	if (!smartContractWalletAddress) return;
	const response = await api_strategies(
		'post',
		`v1/arbitrage-strategies/${startergyId}/post-trade-details`,
		{
			account: smartContractWalletAddress,
			long: {
				marginDeltaUsd: longMargin,
				sizeDeltaUnderlying: longSize
			},
			short: {
				marginDeltaUsd: shortMargin,
				sizeDeltaUnderlying: shortSize
			}
		}
	);
	if (response.status === 201) {
		const data = await response.json();
		return data as StartergyPostTradeDetails;
	}
}

export async function getStrategyPositionsForScw(smartContractWalletAddress: string) {
	const smartWalletAddress = smartContractWalletAddress;
	if (!smartWalletAddress) return;
	const response = await api_strategies(
		'get',
		`v1/arbitrage-strategies/positions?account=${smartContractWalletAddress}`
	);
	if (response.status === 200) {
		const data = await response.json();
		return data as Array<StrategyPosition>;
	}
}
